export default __webpack_public_path__ + "static/hero-paddy-cb04723db54eb81def576094c9346060.jpg";